import { useMemo } from 'react';

import { KPIStatusColors, KPIStatusExplanations } from '../components/DealGPT/utils';
import { AnalysisQuestionStatus } from '../Types/enums';

const useQuestionStatusInfo = (
  status: AnalysisQuestionStatus,
  value: string | null | undefined
) => {
  const statusColor = useMemo(() => {
    const color = KPIStatusColors[status];
    return (
      color ??
      (value
        ? KPIStatusColors[AnalysisQuestionStatus.NEEDS_CONFIRMATION]
        : KPIStatusColors[AnalysisQuestionStatus.NOT_FOUND])
    );
  }, [status, value]);

  const statusExplanation = useMemo(() => {
    const explanation = KPIStatusExplanations[status];
    return (
      explanation ??
      (value
        ? KPIStatusExplanations[AnalysisQuestionStatus.NEEDS_CONFIRMATION]
        : KPIStatusExplanations[AnalysisQuestionStatus.NOT_FOUND])
    );
  }, [status, value]);

  return { statusColor, statusExplanation };
};

export default useQuestionStatusInfo;
